import { render } from "./App.vue?vue&type=template&id=50b90724"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=50b90724&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/messages-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__